import React from 'react';
import Sidebar from './Sidebar';
import './Layout.css';

const Layout = ({ children }) => {
  // Check if mobile on initial load
  const isMobile = () => window.innerWidth <= 768;

  const [isCollapsed, setIsCollapsed] = React.useState(() => {
    // On mobile, default to collapsed (hidden)
    if (isMobile()) return true;
    // On desktop, use saved preference
    return localStorage.getItem('sidebar-collapsed') === '1';
  });

  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    // Only save preference on desktop
    if (!isMobile()) {
      localStorage.setItem('sidebar-collapsed', newState ? '1' : '0');
    }
  };

  return (
    <div className={`app-layout ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Mobile Burger Menu Button */}
      <button
        className="mobile-burger-menu"
        onClick={toggleSidebar}
        aria-label="Toggle menu"
      >
        <span className="burger-line"></span>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
      </button>

      {/* Mobile Backdrop */}
      <div
        className={`sidebar-backdrop ${!isCollapsed ? 'active' : ''}`}
        onClick={() => setIsCollapsed(true)}
      />

      <Sidebar isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
      <main className={`main-content ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
